<template>
  <transition name="fade">
    <div 
      v-if="visible" 
      class="auth-modal-mask" 
      @touchmove.prevent 
      @click="handleClose('cancel')"
    >
      <div class="auth-modal-box" @click.stop>
        
        <div class="modal-body">
          <div class="modal-title">{{ title }}</div>
          <div class="modal-content">
            <div v-for="(line, index) in contentLines" :key="index">{{ line }}</div>
          </div>
        </div>

        <div class="modal-footer">
          <div class="btn cancel" @click="handleClose('cancel')">{{ cancelText }}</div>
          <div class="split-line"></div>
          <div class="btn confirm" @click="handleClose('confirm')">{{ confirmText }}</div>
        </div>
        
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AuthModal',
  props: {
    remove: { type: Function, required: true },
    onConfirm: { type: Function, default: () => {} },
    onCancel: { type: Function, default: () => {} },
    title: { type: String, default: '温馨提示' },
    contentLines: {
      type: Array,
      default: () => [
        '由于Tracker要求，您的账号需要在拳头官网进行授权',
        '您只需要一次授权，即可长期使用战绩查询'
      ]
    },
    cancelText: { type: String, default: '取消' },
    confirmText: { type: String, default: '前往验证' }
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    this.visible = true
  },
  methods: {
    handleClose(type) {
      this.visible = false
      setTimeout(() => {
        this.remove()
        if (type === 'confirm') {
          this.onConfirm()
        } else {
          this.onCancel()
        }
      }, 200)
    }
  }
}
</script>

<style scoped>
.auth-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-modal-box {
  width: 296px;
  background-color: #252525;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.modal-body {
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 20px;
  box-sizing: border-box;
}

.modal-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: #D7D7D9;
  margin-bottom: 8px;
}

.modal-content {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  color: #D7D7D9;
}

.modal-content > div + div {
  margin-top: 4px;
}

.modal-footer {
  height: 48px;
  display: flex;
  align-items: center; 
  border-top: 0.5px solid #323238; 
  box-sizing: border-box;
}

.btn {
  flex: 1; 
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  user-select: none; 
  cursor: pointer;
}


.split-line {
  width: 0.5px;
  height: 100%;
  background-color: #323238;
  opacity: 1;
}

.cancel {
  color: #717173;
}

.confirm {
  color: #EB413D;
}

</style>
